import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';

import { greyLight400 } from '../../../../theme/videa-style-tokens';

const LoadingContainer = styled.div`
  &.loading {
    position: relative;
    align-items: center;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    width: 100%;
    height: 100%;
    min-height: 10em;
    z-index: 15;
  }
  .icon {
    opacity: 0.5;
    margin: auto;
    fill: ${greyLight400};
  }
`;

export const Loading = () => (
  <LoadingContainer className="loading">
    <CircularProgress className="icon" />
  </LoadingContainer>
);
